import {
  Component,
  OnInit,
  AfterViewInit,
  Output,
  EventEmitter,
  ViewChild,
  inject
} from '@angular/core';
import { JedinicaGradiva } from '@app/shared/models/jedinica-gradiva';
import { UIComponents, Item, ListViewProviderDirective } from '@ntap/core';
import { Observable, map, first, tap } from 'rxjs';
import { OdabirJedinicaProviderDirective } from './odabir-jedinica-gradiva.provider';

@Component({
  selector: 'app-select-jedinice-gradiva',
  templateUrl: './select-jedinica-gradiva.component.html'
})
export class SelectJediniceGradivaComponent implements OnInit, AfterViewInit {
  @Output()
  itemSelected = new EventEmitter<JedinicaGradiva[]>();

  @ViewChild(OdabirJedinicaProviderDirective, { static: false })
  appOdabirJedinicaProvider!: OdabirJedinicaProviderDirective;

  private listviewProvider = inject(ListViewProviderDirective);

  tablica = [
    'en~jedinica_gradiva~arhivska_oznaka',
    'en~jedinica_gradiva~glavni_naziv',
    'en~jedinica_gradiva~razina',
    'en~jedinica_gradiva~vrijeme_nastanka_labela',
    'en~jedinica_gradiva~nadredena_jedinica_labela',
    'en~jedinica_gradiva~vrsta_sadrzaja',
    'en~jedinica_gradiva~locked',
    'en~jedinica_gradiva~status_obrade',
    'en~jedinica_gradiva~javno_objavljeno'
  ];

  lista = [
    'en~jedinica_gradiva~arhivska_oznaka',
    'en~jedinica_gradiva~glavni_naziv',
    'en~jedinica_gradiva~content_id',
    'en~jedinica_gradiva~posjednik_naziv',
    'en~jedinica_gradiva~sadrzaj',
    'en~jedinica_gradiva~status_obrade',
    'en~jedinica_gradiva~javno_objavljeno',
    'en~jedinica_gradiva~prava_koristenja'
  ];
  grid = [
    'en~jedinica_gradiva~arhivska_oznaka',
    'en~jedinica_gradiva~glavni_naziv',
    'en~jedinica_gradiva~content_id',
    'en~jedinica_gradiva~posjednik_naziv',
    'en~jedinica_gradiva~sadrzaj',
    'en~jedinica_gradiva~status_obrade',
    'en~jedinica_gradiva~javno_objavljeno',
    'en~jedinica_gradiva~prava_koristenja'
  ];

  INIT_COMP_ID = UIComponents.LISTVIEW;
  currentViewName: string;
  currentViewState: object | null = null;
  currentViewStateFilter: object = {};
  currentViewClass: string;

  disabled$: Observable<boolean>;

  private selectedItems$: Observable<Item[] | null>;

  ngOnInit(): void {
    const parentItemProps = {
      $parentId: (this.listviewProvider.viewState as { $parentId: number })[
        '$parentId'
      ],
      $parentType: (this.listviewProvider.viewState as { $parentType: string })[
        '$parentType'
      ],
      $itemType: (this.listviewProvider.viewState as { $itemType: string })[
        '$itemType'
      ]
    };

    this.currentViewName = 'jedinica_gradiva';
    this.currentViewState = { ...parentItemProps };
    this.currentViewStateFilter = { ...parentItemProps };
  }

  public ngAfterViewInit(): void {
    this.selectedItems$ = this.appOdabirJedinicaProvider.selectedItems$;
    this.disabled$ = this.selectedItems$.pipe(map((i) => !i || i.length == 0));
  }

  public selectItem() {
    this.selectedItems$
      .pipe(
        first(),
        tap((items) => {
          if (!!items && items.length > 0) {
            this.itemSelected.next(items as JedinicaGradiva[]);
          }
        })
      )
      .subscribe();
  }
}
